import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const hrmAttendanceConfig: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Attendance",
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                childComponents: [
                    {
                        componentType: ComponentType.INFO_CARDS,
                        apiname: "/g360/hrms/attendance/statistics",
                        cards: [
                            {
                                name: "Present Days",
                                bindValue: "present_days",
                                icon: "✔️",
                                color: "#34D399",
                                defaultValue: 0,
                                valueFormat: "number",
                            },
                            {
                                name: "Absent Days",
                                bindValue: "absent_days",
                                icon: "❌",
                                color: "#F97316",
                                defaultValue: 0,
                                valueFormat: "number",
                            },
                            {
                                name: "Late Arrivals",
                                bindValue: "late_arrivals",
                                icon: "⏰",
                                color: "#FACC15",
                                defaultValue: 0,
                                valueFormat: "number",
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        childComponents: [
                            {
                                componentType: LayoutTypes.GRID,
                                columnNumber: "m1 t3 w1",
                                childComponents: [
                                    {
                                        componentType: ComponentType.CHECK_IN_OUT_COMPONENT,
                                        dataApi: "checkinout_info",
                                        onPressAction: "checkinout",
                                        logButtonAction: "navigate_2208",
                                        visibility: [2],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            backgroundColor: "hsl(var(--bg-white))",
                            padding: 20,
                            margin: 16,
                            borderRadius: 4,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.CUSTOM,
                                customType: "dateFilter",
                                name: "attendance_date_filter",
                                props: {
                                    filterField: "attendance_date",
                                },
                                style: {},
                            },
                            {
                                componentType: ComponentType.SUMMARY_LIST,
                                titleValue: "attendance_date",
                                apiname: "attendance_summary",
                                Name: "attendance_summary",
                                TableName: "employee_attendance",
                                View: "view_attendance_summary",
                                DisplayName: "Attendance Records",
                                fields: [
                                    {
                                        IncludeLabel: true,
                                        Label: "Date",
                                        BindValue: "date_attendance",
                                        Json_Attribute: "attendance_date",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Employee",
                                        BindValue: "s_select_employee",
                                        Json_Attribute: "employee_name",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Branch",
                                        BindValue: "s_select_branch",
                                        Json_Attribute: "branch_name",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "First Check In",
                                        BindValue: "txt_first_check_in",
                                        Json_Attribute: "first_check_in",
                                        ControlType: "DateTime",
                                        AutoPopulate_format: "time",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Last Check Out",
                                        BindValue: "txt_last_check_out",
                                        Json_Attribute: "last_check_out",
                                        ControlType: "DateTime",
                                        AutoPopulate_format: "time",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Total Hours",
                                        BindValue: "txt_total_hours",
                                        Json_Attribute: "total_hours",
                                        ControlType: "TextView",
                                        AutoPopulate_format: "duration",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Sessions",
                                        BindValue: "txt_session_count",
                                        Json_Attribute: "session_count",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Status",
                                        BindValue: "txt_status",
                                        Json_Attribute: "status",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
